import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import store from "./store/Store";
import router from "./router/Router";
import "./assets/scss/style.scss";
import App from "./App.vue";
import VueFeather from "vue-feather";
import InstantSearch from "vue-instantsearch";
import vuetify from './plugins/vuetify';
// i18n
import i18n from './i18n/i18n.js'
//leaflet
import 'leaflet/dist/leaflet.css'
import 'leaflet-draw/dist/leaflet.draw.css'
import 'leaflet-toolbar/dist/leaflet.toolbar.css'

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import vueHljs from "vue-hljs";
import "vue-hljs/dist/style.css";
import hljs from "highlight.js";
import Vue2LeafletMovingmarker from 'vue2-leaflet-movingmarker';
import VueClipboard from 'vue-clipboard2'; //para copiar texto al portapapeles

import { alerta, destruirAlerta, getServidorPorAmbiente } from "./utils/Utils"
import ErrorHandlerByComponent from "./utils/ErrorHandler.js";

import firebaseConfig from "./services/firebaseConfig.js";

import "./assets/scss/variables-ultrawide.css";

import 'github-markdown-css/github-markdown.css';


let formatcoords = require('formatcoords');

Vue.prototype.$formatcoords = formatcoords;

Vue.component('l-moving-marker', Vue2LeafletMovingmarker);

Vue.use(VueFeather);
/**
 * Usar las alertas de sweetalert2
 */
Vue.use(VueSweetalert2);

Vue.config.productionTip = false;

//use
Vue.use(vueHljs, { hljs });
Vue.use(InstantSearch);
Vue.use(VueClipboard);

Vue.prototype.$messaging = firebaseConfig

export const eventBus = new Vue();

Vue.config.errorHandler = (err, vm, info) => {
    const error = { error: err, location: info, url: globalThis.location.href }
    ErrorHandlerByComponent(error);
};
new Vue({ store, vuetify, router, i18n, render: (h) => h(App) }).$mount("#app");


// Escuchar cambios de storage en TODAS las pestañas
globalThis.addEventListener("storage", (event) => {
    if (event.key === "esCompartirLink") {
        if (event.newValue !== null) {
            destruirAlerta();
        }
    }
});


// ======= Flujo de carga de la aplicación ======= \\
// Ruta pública de "compartir link": se detecta por pathname de forma síncrona
// (sin esperar a que Vue Router resuelva el chunk de CompartirLink.vue y su
// beforeCreate/created marquen 'esCompartirLink' en localStorage), para evitar
// que alerta() llegue a abrirse y luego se cierre, causando un parpadeo visible.
const esRutaCompartirLinkAlCargar = globalThis.location.pathname.startsWith('/aciquicompartirlink/');

// ======= Detección de instancia única entre pestañas ======= \\
// No se puede confiar en sessionStorage.token como señal de "esta pestaña ya
// tiene una sesión legítima": al usar "duplicar pestaña" el navegador clona
// sincrónicamente el sessionStorage completo de la pestaña origen, así que la
// pestaña duplicada también "tiene" el token aunque nunca inició sesión ahí.
// Para distinguir una recarga legítima de una pestaña duplicada se hace un
// ping/pong en tiempo real por BroadcastChannel: solo una pestaña con sesión
// realmente viva puede responder el pong.
const CANAL_INSTANCIA_UNICA = 'aciqui_instancia_unica';
const canalInstanciaUnica = 'BroadcastChannel' in globalThis ? new BroadcastChannel(CANAL_INSTANCIA_UNICA) : null;
const idPestana = crypto.randomUUID();
let pestanaBloqueada = false;

if (canalInstanciaUnica) {
    canalInstanciaUnica.onmessage = ({ data }) => {
        if (!data || data.from === idPestana) return;

        if (data.type === 'ping') {
            // Solo respondo si tengo una sesión viva y no soy yo mismo un duplicado bloqueado
            if (sessionStorage.getItem('token') && !pestanaBloqueada) {
                canalInstanciaUnica.postMessage({ type: 'pong', from: idPestana });
            }
        } else if (data.type === 'pong') {
            // Otra pestaña respondió en tiempo real: sí existe una instancia legítima activa
            pestanaBloqueada = true;
        }
    };
}

// 1.- Cuando la aplicación se inicia se verifica si ya existe una instancia valida del sistema
if (localStorage.getItem('aciqui_instance')) {
    if (localStorage.getItem('esCompartirLink') || esRutaCompartirLinkAlCargar) {
        destruirAlerta();
    } else {
        // Se difiere al siguiente frame: si alerta() se llama en el mismo tick en que
        // arranca el script (antes del primer paint de la página), la transición CSS
        // de fondo de SweetAlert2 no llega a aplicarse y el modal queda con el fondo
        // transparente (se ve la app por detrás), aunque el ícono sí se muestra.
        requestAnimationFrame(() => {
            alerta(); // bloquea de inmediato para evitar parpadeo mientras se confirma con el ping

            if (canalInstanciaUnica) {
                canalInstanciaUnica.postMessage({ type: 'ping', from: idPestana });

                // Ventana breve para que una pestaña realmente activa responda el pong.
                // Si nadie responde, esta es la instancia legítima (recarga o primera carga).
                setTimeout(() => {
                    if (!pestanaBloqueada) {
                        destruirAlerta();
                    }
                }, 300);
            } else if (sessionStorage.getItem('token')) {
                // Sin soporte de BroadcastChannel: se mantiene el comportamiento previo (best-effort)
                destruirAlerta();
            }
        });
    }
}

// 2.- Se verifica el valor la key aciqui_instance del storage y se procede a 'bloquear' o 'liberar' la pagina
globalThis.addEventListener('storage', (event) => {

    if (event.key === 'aciqui_instance' && event.newValue === 'true') {
        if (localStorage.getItem('esCompartirLink')) {
            destruirAlerta();
        } else {
            alerta();
        }

    } else if (event.key === 'aciqui_instance' && event.newValue === null) {
        destruirAlerta();
    }
    if (event.key === 'token' && event.newValue === null) {
        localStorage.removeItem('aciqui_instance');
        destruirAlerta();
    }

    if (event.key === 'esCompartirLink') {
        console.log("se cerrara");

        destruirAlerta();
    }
});


// Cuando se recarga la pagina pero ya hay una instancia válida
window.addEventListener('load', () => {
    if (sessionStorage.getItem('token')) {
        localStorage.setItem('aciqui_instance', 'true');
    }
});

// Cuando se cierra la instancia (pestaña, navegador o navegación fuera del sitio)
// Se usa 'pagehide' porque 'unload' no es confiable en navegadores modernos
// (no siempre se dispara por el bfcache, cierres abruptos, iOS Safari, etc.),
// lo que dejaba la bandera 'aciqui_instance' huérfana en 'true'.
window.addEventListener('pagehide', (event) => {
    // event.persisted === true significa que el navegador guardó la página en el
    // bfcache (ej. el usuario puede volver con el botón "atrás"), no que se cerró.
    // Si esta pestaña quedó bloqueada por ser un duplicado, su sessionStorage.token
    // es una copia clonada del de la pestaña legítima: no debe invalidarlo al cerrarse.
    if (!event.persisted && !pestanaBloqueada && sessionStorage.getItem('token')) {
        // Avisa al backend para liberar la sesión (borra el registro en la allowlist),
        // así la cuenta no queda "atascada" si el usuario cierra la pestaña/navegador
        // sin pasar por el botón "Cerrar sesión". Se usa sendBeacon porque, a diferencia
        // de fetch, garantiza el envío aunque la página se esté descargando.
        if (navigator.sendBeacon) {
            const data = {
                token: sessionStorage.getItem('token'),
                tokenPush: localStorage.getItem('tokenPush') || '',
            };
            const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
            navigator.sendBeacon(`${getServidorPorAmbiente()}/api/auth/eliminar-token`, blob);
        }
        localStorage.removeItem('aciqui_instance');
    }
});

if (typeof alert !== 'undefined') {
    alert = function () { };
}
